import React from 'react';

type BadgeDateTimeProps = {
  value: string;
  unit: string;
  identifiers?: {
    badge_date_time_value_id?: string;
    badge_date_time_unit_id?: string;
  };
};

const BadgeDateTime: React.FC<BadgeDateTimeProps> = ({
  value,
  unit,
  identifiers,
}) => {
  return (
    <div
      className="
        badge-datetime-without-secondary-primary-vertical-padding
        badge-datetime-without-secondary-primary-horizontal-padding
        badge-datetime-without-secondary-border-radius
        badge-datetime-without-secondary-primary-fill
        flex flex-col items-center justify-center
      "
    >
      <span
        className="
          badge-datetime-without-secondary-number-font-family
          badge-datetime-without-secondary-number-font-weight
          badge-datetime-without-secondary-number-font-size
          badge-datetime-without-secondary-number-line-height
          badge-datetime-without-secondary-number-fill
        "
        id={identifiers?.badge_date_time_value_id}
      >
        {value}
      </span>
      <span
        className="
          badge-datetime-without-secondary-unit-font-family
          badge-datetime-without-secondary-unit-font-weight
          badge-datetime-without-secondary-unit-font-size
          badge-datetime-without-secondary-unit-line-height
          badge-datetime-without-secondary-unit-fill
        "
        id={identifiers?.badge_date_time_unit_id}
      >
        {unit}
      </span>
    </div>
  );
};

export default BadgeDateTime;
